function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M332.252,45.662c-.117-.067-.21-.142-.318-.209a7.633,7.633,0,0,0-11.825,6.939,295.53,295.53,0,0,1-1.886,59.193,2.623,2.623,0,0,1-5.171.168c-7.3-36.976-21.656-68.83-30.64-86.363a7.649,7.649,0,0,0-4.727-3.872,281.8,281.8,0,0,0-59.352-9.7,7.644,7.644,0,0,0-7.844,9.42c8.339,34.738,6.118,73.079,4.107,92.548a2.614,2.614,0,0,1-5.112.461c-6.57-22.787-21.463-71.185-36.2-96.378a7.653,7.653,0,0,0-7.308-3.755c-20.013,1.869-39.255,4.743-56.4,12.512h-.017c-3.394,0-5.414,3.646-4.852,7.233,4.995,31.528,2.682,60.869.377,78.275a2.381,2.381,0,0,1-2.514,1.986,2.734,2.734,0,0,1-2.648-2.246A324.817,324.817,0,0,0,80.237,48.964a9.457,9.457,0,0,0-13.451-4.526C20.608,71.256,0,102.6,0,134.606c0,68.085,88.818,76.155,198.379,76.155s198.37-8.071,198.37-76.155C396.774,105.265,378.463,76.394,332.252,45.662Z",
  transform: "translate(0 -11.801)",
  fill: "rgba(147,147,147,0.69)"
}));

function SvgBread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bread",
    xmlns: "http://www.w3.org/2000/svg",
    width: 396.749,
    height: 198.961,
    viewBox: "0 0 396.749 198.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/bread.018a93b1.svg";
export { ForwardRef as ReactComponent };